var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.propertyDetails && this.propertyDetails.id)?_c('div',{staticClass:"search-reservation-wrapper flexed-column"},[_c('default-header'),_c('div',{staticClass:"search-content flexed justify-center"},[_c('router-view',{staticClass:"main"})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }